// src/admin/AdminLayout.jsx - Apartment Management System
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/header/Header';

const AdminLayout = () => {
  const { isDarkMode, isRTL } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false); // Start closed on mobile
  const [isMobile, setIsMobile] = useState(false);

  // Handle responsive behavior
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // Auto-close sidebar on mobile, auto-open on deskt
      // op
      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Calculate main content margin based on sidebar state
  const getMainContentMargin = () => {
    if (isMobile) return '0px'; // No margin on mobile
    return sidebarOpen ? '280px' : '80px';
  };

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-zinc-950' : 'bg-gray-50'} ${isRTL ? 'rtl' : 'ltr'} relative`}>

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} isMobile={isMobile} />

      {/* Mobile Overlay */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content Area */}
      <div
        className="flex flex-col min-h-screen transition-all duration-300 ease-in-out"
        style={{
          [isRTL ? 'marginRight' : 'marginLeft']: getMainContentMargin()
        }}
      >
        {/* Header - Fixed at top with proper z-index */}
        <div className="sticky top-0 z-30">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        </div>

        {/* Page Content - Flexible grow */}
        <main className="flex-1 p-4 md:p-6 overflow-x-hidden">
          <div className="max-w-full">
            <Outlet />
          </div>
        </main>

        {/* Optional Footer Space */}
        <div className="h-4"></div>
      </div>
    </div>
  );
};

export default AdminLayout;